import { Button } from '@monorepo/shared/componentsV2/Button';
import { BaseModal } from '@monorepo/shared/componentsV2/modals/BaseModal';
import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { useFormTemplateContext } from '../../EditFormTemplatePage/FormTemplateContext';
import { CreateFormTemplateFieldGroupFormValues } from '../types';
import { EditSectionForm } from './EditSectionForm';

export type CopySectionModalProps = {
  copiedSectionFormValues: CreateFormTemplateFieldGroupFormValues;
  isOpen: boolean;
  onClose: () => void;
};

export function CopySectionModal({
  copiedSectionFormValues,
  isOpen,
  onClose,
}: CopySectionModalProps) {
  const {
    formTemplateHelpers: { copyGroup },
  } = useFormTemplateContext();

  const handleCopySubmit = useCallback(
    (groupFormValues: CreateFormTemplateFieldGroupFormValues) => {
      copyGroup(groupFormValues);
      onClose();
    },
    [onClose, copyGroup],
  );

  if (!isOpen) {
    return null;
  }

  return (
    <Form
      onSubmit={handleCopySubmit}
      initialValues={{
        ...copiedSectionFormValues,
        name: `${copiedSectionFormValues.name} (copy)`,
      }}
      subscription={{ invalid: true }}
    >
      {({ handleSubmit, invalid }) => (
        <BaseModal
          title="Copy section"
          open={isOpen}
          onClose={onClose}
          maxWidth="sm"
          buttons={
            <>
              <Button color="primary" onClick={onClose} type="button">
                Cancel
              </Button>
              <Button
                color="primary"
                disabled={invalid}
                onClick={handleSubmit}
                type="submit"
                variant="contained"
              >
                Copy
              </Button>
            </>
          }
        >
          <EditSectionForm forceShowErrors isEditing={false} />
        </BaseModal>
      )}
    </Form>
  );
}
